import {
  PendingQuestionEdit,
  PendingSlideEdit,
} from '@/components/courses/course-changes/course-changes.types';
import { useCallback, useState } from 'react';

export const useCourseChangesPendingEdits = () => {
  const [pendingSlideEdits, setPendingSlideEdits] = useState<
    PendingSlideEdit[]
  >([]);
  const [pendingQuestionEdits, setPendingQuestionEdits] = useState<
    PendingQuestionEdit[]
  >([]);

  const handleSlideEdit = useCallback((edit: PendingSlideEdit) => {
    setPendingSlideEdits((prev) => {
      const filtered = prev.filter(
        (e) =>
          !(
            e.contentIndex === edit.contentIndex &&
            e.slideIndex === edit.slideIndex &&
            e.field === edit.field &&
            e.imageIndex === edit.imageIndex
          ),
      );
      return [...filtered, edit];
    });
  }, []);

  const handleQuestionEdit = useCallback((edit: PendingQuestionEdit) => {
    setPendingQuestionEdits((prev) => {
      const filtered = prev.filter(
        (e) =>
          !(
            e.contentIndex === edit.contentIndex &&
            e.questionIndex === edit.questionIndex &&
            e.field === edit.field
          ),
      );
      return [...filtered, edit];
    });
  }, []);

  const clearPendingEdits = useCallback(() => {
    setPendingSlideEdits([]);
    setPendingQuestionEdits([]);
  }, []);

  return {
    pendingSlideEdits,
    pendingQuestionEdits,
    handleSlideEdit,
    handleQuestionEdit,
    clearPendingEdits,
  };
};
